export enum ChatCommands {
  Revote = '/revote',
}
